import { inject, Injectable } from '@angular/core';
import { DocumentSubFolderName } from "@models/common/document-sub-folder-name.enum";
import {
  commonFileUploadConfig,
  IFileUploadConfig,
  UploadFilesModalComponent
} from "@shared/components/documents-related/annual-upload-files-modal/upload-files-modal.component";
import { FilesApiService } from "@shared/services/files-api.service";
import { combineLatest, from, map, Observable, switchMap } from "rxjs";
import { ModalFormsService } from "../../forms/services/modal-forms.service";
import { toBase64 } from "../utils/to-base64";

@Injectable({ providedIn: 'root' })
export class FilesService {
  modalFormsService = inject(ModalFormsService);
  filesApiService = inject(FilesApiService);

  openUploadFilesModal(documentId: string, subfolder = DocumentSubFolderName.Upload, config: Partial<IFileUploadConfig> = commonFileUploadConfig): Observable<File[]> {
    const modalRef = this.modalFormsService.openModal(UploadFilesModalComponent, { size: 'lg' });
    const componentInstance = modalRef.componentInstance as UploadFilesModalComponent;

    componentInstance.config = { ...commonFileUploadConfig, ...config };

    return componentInstance.save
      .pipe(
        switchMap((files: File[]) => {
          const fileTransformation = files.map(file => {
            return from(toBase64(file))
              .pipe(
                map((base64File) => ({ fileName: file.name, base64FileContent: base64File })),
              );
          });

          return combineLatest(fileTransformation)
            .pipe(
              switchMap((body) => {
                return this.filesApiService.uploadFilesBulk(documentId, subfolder, body)
                  .pipe(map(() => files));
              })
            );
        }),
      );
  }
}
